// extracted by mini-css-extract-plugin
export default {"image":"UpdatePassword_image__GQCRk","logo":"UpdatePassword_logo__Sk4AU","form":"UpdatePassword_form__ppGIQ"};